import styles from "../Success/Success.module.scss";
import contest_arrow from "../../../../assets/img/contest_arrow.svg";
import {useNavigate} from "react-router-dom";
import copy_img from "../../../../assets/img/copy.svg"
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {fetchContest, fetchMyTeam} from "../../NewYearEvent/eventSlice";
import Loader from "../../../subsidiary/Loader/Loader";

const Success = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const contest = localStorage.getItem('contestID');
    const token = localStorage.getItem('token');
    const loading = useSelector(state => state.eventSlice.eventLoading)
    const team = useSelector(state => state.eventSlice.myTeam)

    useEffect(() => {
        dispatch(fetchMyTeam({token, contest}))
    },[dispatch])

    return (
        <section className='main'>
            {loading ? <Loader/> :

            <div className='content-wrapper'>
                <h2 className={styles.successHeading}>Успешно!</h2>
                <p className={styles.successText}>Ваша заявка успешно отправлена!</p>
                <div className={styles.numberParticipantContainer}>
                    <p className={styles.numberParticipant}>Ваш номер участника</p>
                    <div className={styles.copyContainer}>
                        <button className={styles.numberContainer}>
                            {team?.team_number}
                        </button>
                        <img src={copy_img} alt={""} className={styles.copyImg}/>
                    </div>
                </div>
                <div className={styles.btnContainer}>
                    <button
                        onClick={() => navigate("/")}
                        className={styles.successBtn}
                    >
                        Готово
                    </button>
                </div>
            </div>
            }
        </section>
    )
}

export {Success}